import { Injectable } from "@angular/core";
import { IKeyboardShortcutListenerOptions, KeyboardKeys } from "ngx-keyboard-shortcuts";
import { interval } from "rxjs";
@Injectable()
export class Constant {
  readonly signUpWarning:string="Please Sign Up/Sign In Before Sign-Out"
  readonly fileBigSize: string = "10Mb Max File Size..";
  readonly maxCharacterSize: number = 50;
  readonly uploadFileSize: number = 10485760;//10mb to bytes
  readonly uploadQueryFileSize: number = 1e+6;
  readonly signUploadFileSize: number = 400000;
  readonly documentTypeList: string[] = ["Proof Of Id", "Proof Of Address"];
  readonly yesNoList: string[] = ["Yes", "No"];
  readonly reqTypeList: string[] = ["Mandatory", "Optional"];
  readonly letterTypeList: string[] = ["Company", "Employee", "Both"];
  readonly setUpStatusList: string[] = ["All", "Active", "Cancelled"];
  readonly ratingTypeList: string[] = ['Number', 'Rating', 'Star', 'Time'];
  readonly yesClicked: boolean = true;
  readonly issueStatusList: string[] = ["Approved", "Declined"];
  readonly cancelStatus: string = "Are you want to cancel....?";
  readonly requestQuantity: string = "Request Quantity has reached it's MaxQuantity";
  readonly logoutErrorToast:string="Unable to log out. Please clear your cache and try again.";


  readonly invalidFormToast: string = "Oops! Invalid or No data found. Please try again.";
  readonly dateFormatForDBServer: string = 'YYYY-MM-DD';
  readonly createdToast: string = " has been created, wait for verification";
  readonly updateToast: string = " has been updated";
  readonly dateTimeFormatForDBServer: string = "YYYY-MM-DD HH:mm:ss"
  readonly dateTimeFormatForView: string = "dd-MM-yyyy HH:mm:ss"
  readonly SaveData: string = "Are you sure want to save?";
  readonly deliverData: string = "Are you sure want to deliver?";
  readonly startRideData: string = "Are you sure to start the ride?";

  readonly webOrderConfirmationMessage: string = "You have a new order?";
  readonly URL_WEB_ORDER: string = "order/web-order/web-order-confirmation";
  readonly parkSubMessage: string = "Do you wish to Proceed?";
  readonly statusUpdateToast: string = "Success! Status updated. ";
  readonly noDataAvailableToast: string = "Sorry, no data available";

  readonly DELIVERED: string = "Delivered";
  readonly DELIVERY_RESCHEDULE: string = "Re-Scheduled";
  readonly DELIVERY_CANCEL: string = "Delivery Cancelled";
  readonly DELIVERY_PICK_UP: string = "Picked-Up";
  readonly DELIVERY_PICK_UP_CANCELLED: string = "Pick-Up-Cancelled";
  readonly ASSIGNED: string = "Assigned";
  readonly RE_ASSIGNED: string = "Re-Assigned";
  readonly RIDER_ACCEPTED: string = "Rider Accepted";
  readonly RIDER_DECLINED: string = "Rider Declined";
  readonly checkPaymentToast: string = "Oops! No payment has been made for this shipment.";
  readonly deliveryNotAllowedToast: string = "Looks like you haven't started yet. Please press the 'Start' button to begin";
  readonly SHIPPING: string = "Shipping";
  readonly paymentSuccessToast: string = "Congratulations! Your payment was successful. ";
  readonly imageUploadToast: string = "Image Uploaded";
  readonly duplicateCouponCode: string = "Duplicate coupon code detected."
  readonly intervalTimeForSearch = interval(2000);
  readonly SmsToast: string = "Success! SMS sent to customer mobile number.";
  readonly notAllowedToast: string = "Access Denied! You are not allowed to perform this operation.";
  readonly serverSideErrorToast: string = "Oops! Server-side error occurred. Please try again later.";
  readonly zeroAmountToast: string = "Error! The amount cannot be zero. Please enter a valid amount.";
  readonly enterAmountToast: string = "Attention! Please enter amount.";
  readonly provideAllValueToast: string = "Attention! Provide all the required values before proceeding.";
  readonly paymentRequestToast: string = "Pay through UPI request has been sent to your mobile.";
  readonly enterAmountandPayToast: string = "Attention! Please provide payer VA and amount.";
  readonly paymentFailedToast: string = "Sorry! Your payment has failed.";
  readonly EnterAmtandCustomerToast: string = "Attention! Please select customer enter amount.";
  readonly walletBalanceToast: string = "Error: The wallet balance cannot be greater than the usable wallet balance.";
  readonly sendRequestToast: string = "Alert! Send a request to fetch payment data.";
  readonly linkSendToast: string = "The payment link has been sent successfully. ";
  readonly selectOpeningBalanceTypToast: string = "Alert: Select customer opening balance type.";
  readonly savedSuccessfullyWithModuleToast: string = "data has been successfully saved.";
  readonly invalidMobileToast: string = "Alert! Invalid mobile number";
  readonly OTPToast: string = " OTP has been sent to your registered mobile";
  readonly OTPSentCustomerToast: string = " OTP has been sent to your customer's mobile";
  readonly OTPresentToast: string = " OTP has been resent to your registered mobile";
  readonly OTPverfiedToast: string = "Congratulations! Your OTP has been verified.";
  readonly invalidOTPToast: string = "Alert! Invalid OTP";
  readonly feedbackToast: string = "Congratulations!Thank you for taking the time to share your feedback.";
  readonly logoutToast: string = "Please wait: We are currently logging you out of your account.";
  readonly noDataAvailableToastDateRange: string = "Sorry, no data available for the selected date range.";
  readonly requestraiseToast: string = "Success: Dispute request has been submitted.";

  dilogcloseShortcut: IKeyboardShortcutListenerOptions = {
    description: 'dilogclose',
    keyBinding: [KeyboardKeys.Alt, 'Delete']
  };
  dilogsaveShortcut: IKeyboardShortcutListenerOptions = {
    description: 'dilogsave',
    keyBinding: [KeyboardKeys.Alt, 'Enter']
  };

}
